import { Button, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	getSupplierTypeById,
	postSupplierType,
	updateSupplierType,
} from "../../../../api/supplierType";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useSkeleton } from "../../../hooks/useSkeleton";

function getEmptySupplierType() {
	return {
		descripcion: null,
	};
}

export default function EditSupplierTypesPage() {
	const [supplierType, setSupplierType] = useState(getEmptySupplierType());

	const supplierTypeId = useParams().id;
	const history = useHistory();
	const location = useLocation();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	const handleBack = () => {
		const prevTablePage = location.state?.page;

		history.push(
			`/tipos-proveedores${prevTablePage ? "?page=" + prevTablePage : ""}`
		);
	};

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		if (!supplierTypeId) {
			disableLoadingData();
			return;
		}
		getSupplierTypeById(supplierTypeId, loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setSupplierType(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage:
						"No se ha podido obtener el tipo de proveedor.",
				});
				handleBack();
			});
	}, [supplierTypeId, disableLoadingData, history]);

	function saveSupplierType() {
		if (!supplierTypeId) {
			postSupplierType(supplierType, loggedUser?.accessToken)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "¡Guardado!",
							customMessage:
								"Tipo de proveedor guardado con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage:
							"No se ha podido guardar el tipo de proveedor.",
					});
				});
		} else {
			updateSupplierType(
				supplierTypeId,
				supplierType,
				loggedUser?.accessToken
			)
				.then((res) => {
					if (res.status === 204) {
						alertSuccess({
							title: "¡Guardado!",
							customMessage: "Cambios guardados con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "No se han podido guardar los cambios.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setSupplierType({ ...supplierType, [element]: event.target.value });
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title="Tipo de proveedor">
						<CardHeaderToolbar>
							<Button
								onClick={() => saveSupplierType()}
								variant="outlined"
								color="primary"
							>
								Guardar tipo
							</Button>
						</CardHeaderToolbar>
					</CardHeader>
					<CardBody>
						<TextField
							id={`descripcion`}
							label="Descripción"
							value={supplierType.descripcion}
							onChange={handleChange("descripcion")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
					</CardBody>
				</Card>
				<Button
					onClick={handleBack}
					variant="outlined"
					style={{ marginRight: "20px" }}
				>
					Atrás
				</Button>
				<Button
					onClick={() => saveSupplierType()}
					variant="outlined"
					color="primary"
				>
					Guardar tipo
				</Button>
			</>
		);
}
